import { env } from "configs/EnvironmentConfig";
import { SESSION_KEY } from "store/auth/login/actionTypes";
import fetch from "../auth/FetchInterceptor";
import fetchNoAuth from "../auth/FetchNoAuthInterceptor";
import fetchRefreshToken from "../auth/FetchRefreshTokenInterceptor";

const authenService = {};

authenService.loginUser = function (data) {
  return fetchNoAuth({
    url: "/api/authenticate",
    method: "post",
    data: data,
  });
};

//get-registered-app
authenService.getRegisteredApp = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/microservice-management/get-registered-app`,
    method: "get",
  });
};

// get final auth
authenService.getFinalAuth = function (data) {
  return fetch({
    url: `${env.API_MSCSM}/api/authorization/get-app-jwt`,
    method: "post",
    data: {
      ...data,
      // accessTokenValidityInMilliseconds: env.ACCESS_TOKEN_VALIDITY_MILLISECONDS,
      // refreshTokenValidityInMilliseconds: env.REFRESH_TOKEN_VALIDITY_MILLISECONDS,
      metadata: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
      },
    },
  });
};

// addNewUser
authenService.addNewUser = function (data) {
  return fetch({
    url: `${env.API_MSP}/users`,
    method: "post",
  });
};

// changePassword
authenService.changePassword = function (data) {
  return fetch({
    url: `${env.API_MSP}/my/change-password`,
    method: "post",
    data: data,
  });
};

// getMyFilter
authenService.getMyFilter = function () {
  return fetch({
    url: `${env.API_MSP}/my/filter`,
    method: "get",
  });
};

// saveMyFilter
authenService.saveMyFilter = function ({
  screenData = undefined,
  screenFilterCode,
  columnFilter,
  columnFilterValue,
  columnsVisibleInvoice,
}) {
  return fetch({
    url: `${env.API_MSP}/my/filter`,
    method: "post",
    data: {
      ...screenData,
      [screenFilterCode]: {
        filterQuery: {
          ...columnFilter,
        },
        filterValue: {
          ...columnFilterValue,
        },
        columnsVisible: {
          ...columnsVisibleInvoice,
        },
      },
    },
  });
};

authenService.refreshToken = function (data) {
  return fetchRefreshToken({
    url: `${env.API_MSCSM}/user/refresh-token`,
    method: "post",
    data: data,
  });
};

authenService.logout = function () {
  return fetch({
    url: `${env.API_MSCSM}/user/logout`,
    method: "post",
    data: {
      sessionKey: localStorage.getItem(SESSION_KEY),
    },
  });
};

export default authenService;
